import { trans } from '@lingoda/i18n';
import { type CheckoutAgreements } from './types';

export interface AgreementsFormValues {
    agreements?: Record<string, boolean | undefined>;
}

export const validateAgreements = (
    agreements: CheckoutAgreements,
    values: AgreementsFormValues,
) => {
    const errors: { [key: string]: unknown } = {};

    const agreementsValues = values.agreements || {};

    agreements.forEach(({ id }) => {
        if (!agreementsValues[id]) {
            errors[id] = trans('form-validation-terms-and-conditions', {}, 'public-common');
        }
    });

    return Object.values(errors).length > 0 ? errors : undefined;
};
